import ViewVendor from '../../pages/Vendor/ViewVendor';
import { vendorStore } from '../../stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const ViewVendorContainer = ({ closeModal, goToEditVendor, goBack }) => {
	const [vendorViewMenu, setVendorViewMenu] = useState(false);

	const showVendorViewMenu = () => {
		setVendorViewMenu(!vendorViewMenu);
	};

	return (
		<ViewVendor
			closeModal={closeModal}
			vendorViewMenu={vendorViewMenu}
			vendor={vendorStore.selectedVendor}
			showVendorViewMenu={showVendorViewMenu}
			goToEditVendor={goToEditVendor}
			goBack={goBack}
		/>
	);
};

export default observer(ViewVendorContainer);
